import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ManageAccountTypes.css";
const ManageAccountTypes = () => {
  const [accountTypes, setAccountTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    ac_index: "",
    ac_name: "",
    ac_group: "",
    ac_min_deposit: "",
    ac_max_deposit: "",
    ac_max_leverage: "",
    ac_spread: "",
    ac_swap: "",
    ac_commission: "",
    ib_commission1: "",
    ib_commission2: "",
    ib_commission3: "",
    ib_commission4: "",
    ib_commission5: "",
    ib_commission6: "",
    ib_commission7: "",
    ib_commission8: "",
    ib_commission9: "",
    ib_commission10: "",
  });
  const FETCH_API =
    "https://server.majestyfx.com/admin_fetch_accounttypes.php";
  const UPDATE_API =
    "https://server.majestyfx.com/admin_updateaccounttypes.php";
  useEffect(() => {
    fetchAccountTypes();
  }, []);
  const fetchAccountTypes = async () => {
    setLoading(true);
    try {
      const response = await axios.get(FETCH_API);
      if (response.data.success) {
        setAccountTypes(response.data.data || []);
      } else {
        alert("Failed to fetch account types");
      }
    } catch (error) {
      console.error("Error fetching account types:", error);
      alert("Error fetching account types. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleEdit = (account) => {
    setFormData({
      ac_index: account.ac_index,
      ac_name: account.ac_name.trim(),
      ac_group: account.ac_group,
      ac_min_deposit: account.ac_min_deposit,
      ac_max_deposit: account.ac_max_deposit,
      ac_max_leverage: account.ac_max_leverage,
      ac_spread: account.ac_spread,
      ac_swap: account.ac_swap,
      ac_commission: account.ac_commission,
      ib_commission1: account.ib_commission1,
      ib_commission2: account.ib_commission2,
      ib_commission3: account.ib_commission3,
      ib_commission4: account.ib_commission4,
      ib_commission5: account.ib_commission5,
      ib_commission6: account.ib_commission6,
      ib_commission7: account.ib_commission7,
      ib_commission8: account.ib_commission8,
      ib_commission9: account.ib_commission9,
      ib_commission10: account.ib_commission10,
    });
    setShowModal(true);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const updateData = {
        ac_index: formData.ac_index,
        ac_name: formData.ac_name,
        ac_group: formData.ac_group,
        ac_min_deposit: parseFloat(formData.ac_min_deposit),
        ac_max_deposit: parseFloat(formData.ac_max_deposit),
        ac_max_leverage: parseFloat(formData.ac_max_leverage),
        ac_spread: parseFloat(formData.ac_spread),
        ac_swap: formData.ac_swap,
        ac_commission: formData.ac_commission,
        ib_commission1: formData.ib_commission1,
        ib_commission2: formData.ib_commission2,
        ib_commission3: formData.ib_commission3,
        ib_commission4: formData.ib_commission4,
        ib_commission5: formData.ib_commission5,
        ib_commission6: formData.ib_commission6,
        ib_commission7: formData.ib_commission7,
        ib_commission8: formData.ib_commission8,
        ib_commission9: formData.ib_commission9,
        ib_commission10: formData.ib_commission10,
      };
      const response = await axios.post(UPDATE_API, updateData);
      if (response.data.success) {
        alert("Account type updated successfully!");
        setShowModal(false);
        fetchAccountTypes();
      } else {
        alert(
          "Failed to update account type: " +
            (response.data.message || "Unknown error")
        );
      }
    } catch (error) {
      console.error("Error updating account type:", error);
      alert("Error updating account type. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  return (
    <div className="manage-account-types-page">
      {" "}
      <div className="page-header">
        {" "}
        <h1>Manage Setting Types</h1>{" "}
        <button
          className="refresh-btn"
          onClick={fetchAccountTypes}
          disabled={loading}
        >
          {" "}
          <i className="fas fa-sync-alt"></i> Refresh{" "}
        </button>{" "}
      </div>{" "}
      {loading && !showModal && (
        <div className="loading-spinner">
          {" "}
          <i className="fas fa-spinner fa-spin"></i> Loading...{" "}
        </div>
      )}{" "}
      <div className="account-types-container">
        {" "}
        <div className="account-types-grid">
          {" "}
          {accountTypes.map((account) => (
            <div key={account.ac_index} className="account-type-card">
              {" "}
              <div className="card-header">
                {" "}
                <h3>{account.ac_name}</h3>{" "}
                <button
                  className="edit-btn"
                  onClick={() => handleEdit(account)}
                >
                  {" "}
                  <i className="fas fa-edit"></i> Edit{" "}
                </button>{" "}
              </div>{" "}
              <div className="card-body">
                {" "}
                <div className="info-row">
                  {" "}
                  <span className="label">Group:</span>{" "}
                  <span className="value">{account.ac_group}</span>{" "}
                </div>{" "}
                <div className="info-row">
                  {" "}
                  <span className="label">Min Deposit:</span>{" "}
                  <span className="value">${account.ac_min_deposit}</span>{" "}
                </div>{" "}
                <div className="info-row">
                  {" "}
                  <span className="label">Max Deposit:</span>{" "}
                  <span className="value">${account.ac_max_deposit}</span>{" "}
                </div>{" "}
                <div className="info-row">
                  {" "}
                  <span className="label">Max Leverage:</span>{" "}
                  <span className="value">1:{account.ac_max_leverage}</span>{" "}
                </div>{" "}
                <div className="info-row">
                  {" "}
                  <span className="label">Spread:</span>{" "}
                  <span className="value">{account.ac_spread} pips</span>{" "}
                </div>{" "}
                <div className="info-row">
                  {" "}
                  <span className="label">Swap:</span>{" "}
                  <span className="value">{account.ac_swap}</span>{" "}
                </div>{" "}
                <div className="info-row">
                  {" "}
                  <span className="label">Commission:</span>{" "}
                  <span className="value">{account.ac_commission}</span>{" "}
                </div>{" "}
               {/*
<div className="ib-commissions">
  <strong>IB Commissions:</strong>
  <div className="ib-grid">
    <span>L1: {account.ib_commission1}</span>
    <span>L2: {account.ib_commission2}</span>
    <span>L3: {account.ib_commission3}</span>
    <span>L4: {account.ib_commission4}</span>
    <span>L5: {account.ib_commission5}</span>
    <span>L6: {account.ib_commission6}</span>
    <span>L7: {account.ib_commission7}</span>
    <span>L8: {account.ib_commission8}</span>
    <span>L9: {account.ib_commission9}</span>
    <span>L10: {account.ib_commission10}</span>
  </div>
</div>
*/}
{" "}
              </div>{" "}
            </div>
          ))}{" "}
        </div>{" "}
      </div>{" "}
      {/* Edit Modal */}{" "}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          {" "}
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {" "}
            <div className="modal-header">
              {" "}
              <h2>Edit Account Type</h2>{" "}
              <button className="close-btn" onClick={handleCloseModal}>
                {" "}
                <i className="fas fa-times"></i>{" "}
              </button>{" "}
            </div>{" "}
            <form onSubmit={handleSubmit} className="edit-form">
              {" "}
              <div className="form-section">
                {" "}
                <h3>Basic Information</h3>{" "}
                <div className="form-grid">
                  {" "}
                  <div className="form-group">
                    {" "}
                    <label>Account Name *</label>{" "}
                    <input
                      type="text"
                      name="ac_name"
                      value={formData.ac_name}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter account name"
                    />{" "}
                  </div>{" "}
                  <div className="form-group">
                    {" "}
                    <label>Account Group *</label>{" "}
                    <input
                      type="text"
                      name="ac_group"
                      value={formData.ac_group}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter account group"
                    />{" "}
                  </div>{" "}
                  <div className="form-group">
                    {" "}
                    <label>Min Deposit *</label>{" "}
                    <input
                      type="number"
                      name="ac_min_deposit"
                      value={formData.ac_min_deposit}
                      onChange={handleInputChange}
                      required
                      min="0"
                      placeholder="Enter min deposit"
                    />{" "}
                  </div>{" "}
                  <div className="form-group">
                    {" "}
                    <label>Max Deposit *</label>{" "}
                    <input
                      type="number"
                      name="ac_max_deposit"
                      value={formData.ac_max_deposit}
                      onChange={handleInputChange}
                      required
                      min="0"
                      placeholder="Enter max deposit"
                    />{" "}
                  </div>{" "}
                  <div className="form-group">
                    {" "}
                    <label>Max Leverage *</label>{" "}
                    <input
                      type="number"
                      name="ac_max_leverage"
                      value={formData.ac_max_leverage}
                      onChange={handleInputChange}
                      required
                      min="1"
                      placeholder="Enter max leverage"
                    />{" "}
                  </div>{" "}
                  <div className="form-group">
                    {" "}
                    <label>Spread *</label>{" "}
                    <input
                      type="number"
                      step="0.1"
                      name="ac_spread"
                      value={formData.ac_spread}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter spread"
                    />{" "}
                  </div>{" "}
                  <div className="form-group">
                    {" "}
                    <label>Swap *</label>{" "}
                    <input
                      type="text"
                      name="ac_swap"
                      value={formData.ac_swap}
                      onChange={handleInputChange}
                      required
                      placeholder="e.g., 15 Day Free"
                    />{" "}
                  </div>{" "}
                  <div className="form-group">
                    {" "}
                    <label>Commission *</label>{" "}
                    <input
                      type="text"
                      name="ac_commission"
                      value={formData.ac_commission}
                      onChange={handleInputChange}
                      required
                      placeholder="e.g., Zero or 5$"
                    />{" "}
                  </div>{" "}
                </div>{" "}
              </div>{" "}
              <div className="form-section">
                {" "}
                <h3>IB Commission Levels</h3>{" "}
                <div className="form-grid ib-commission-grid">
                  {" "}
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((level) => (
                    <div className="form-group" key={level}>
                      {" "}
                      <label>Level {level}</label>{" "}
                      <input
                        type="text"
                        name={`ib_commission${level}`}
                        value={formData[`ib_commission${level}`]}
                        onChange={handleInputChange}
                        placeholder="0"
                      />{" "}
                    </div>
                  ))}{" "}
                </div>{" "}
              </div>{" "}
              <div className="form-actions">
                {" "}
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={handleCloseModal}
                  disabled={loading}
                >
                  {" "}
                  Cancel{" "}
                </button>{" "}
                <button type="submit" className="submit-btn" disabled={loading}>
                  {" "}
                  {loading ? (
                    <>
                      {" "}
                      <i className="fas fa-spinner fa-spin"></i> Updating...{" "}
                    </>
                  ) : (
                    <>
                      {" "}
                      <i className="fas fa-save"></i> Update Account Type{" "}
                    </>
                  )}{" "}
                </button>{" "}
              </div>{" "}
            </form>{" "}
          </div>{" "}
        </div>
      )}{" "}
    </div>
  );
};
export default ManageAccountTypes;
